export default "__VITE_ASSET__S39mmwoi__"